import React from 'react';

import TabbedPageControl from '../../components/TabbedPageControl';
import ProjectSummary from '../../containers/ProjectsContainer/ProjectSummary';
import CloseoutSummary from './CloseoutSummary';
import ProjectGroupsSummary from './ProjectGroupsSummary';
import './ProjectSummaryContainer.scss';

export default class ProjectSummaryContainer extends React.Component {
  constructor(props) {
    super(props);
    
    // constants for tab names
    this.projectSummaryTab = 'summary';
    this.projectGroupsTab = 'groups';
    this.projectCloseoutsTab = 'closeouts';
    
    this.state = {
      selectedTabName: '',
    };
    this.selectTab = this.selectTab.bind(this);
  }

  componentDidMount() {
    this.checkSelectTab();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkSelectTab();
  }

  checkSelectTab() {
    let { selectedTabName } = this.state;
    const pathParts = this.props.history.getCurrentLocation().pathname.split('/');
    if (pathParts.length > 2) {
      selectedTabName = pathParts[2];
    }
    if (selectedTabName != this.state.selectedTabName) {
      this.setState({ selectedTabName });
    }
  }

  selectTab(tabName) {
    this.props.history.replace('/projects/' + tabName);
  }

  render() {
    const { selectedTabName } = this.state;
    let tabContent;

    if (selectedTabName === this.projectCloseoutsTab) {
      tabContent = <CloseoutSummary />;
    } else if (selectedTabName === this.projectGroupsTab) {
      tabContent = <ProjectGroupsSummary />;
    } else {
      tabContent = <ProjectSummary />;
    }

    return (
      <div className='project-summary-container'>
        <TabbedPageControl
          tabItems={[this.projectSummaryTab, this.projectGroupsTab, this.projectCloseoutsTab]}
          selectedTabName={selectedTabName}
          handleClick={this.selectTab}
        />
        <div className='project-summary-container__content'>
          {tabContent}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/index.js